function normalizedAddress(value) {
    return String(value || '').toLowerCase()
}

export function createMigrationValidationError(code, values = {}) {
    const error = new Error(code)
    error.code = code
    error.values = values
    return error
}

export function validateMigrationTarget(source, target, factoryApproved) {
    if (normalizedAddress(source.marketAddress) === normalizedAddress(target.marketAddress)) {
        throw createMigrationValidationError('migrationSameMarket')
    }
    if (normalizedAddress(source.factoryAddress) !== normalizedAddress(target.factoryAddress)) {
        throw createMigrationValidationError('migrationFactoryMismatch')
    }
    if (normalizedAddress(source.nftAddress) !== normalizedAddress(target.nftAddress)) {
        throw createMigrationValidationError('migrationNftMismatch')
    }
    if (normalizedAddress(source.owner) !== normalizedAddress(target.owner)) {
        throw createMigrationValidationError('migrationOwnerMismatch')
    }
    if (Number(target.version) <= Number(source.version)) {
        throw createMigrationValidationError('migrationVersionTooLow', {
            sourceVersion: Number(source.version),
            targetVersion: Number(target.version),
        })
    }
    if (!factoryApproved) {
        throw createMigrationValidationError('migrationNotApproved')
    }
    return true
}

function nestedErrorData(value, seen = new Set()) {
    if (typeof value === 'string' && value.startsWith('0x')) return value
    if (!value || typeof value !== 'object' || seen.has(value)) return ''
    seen.add(value)
    for (const key of ['data', 'error', 'originalError']) {
        const found = nestedErrorData(value[key], seen)
        if (found) return found
    }
    return ''
}

export function migrationErrorKey(error) {
    const data = nestedErrorData(error)
    return data.slice(0, 10).toLowerCase() === '0x7657d189'
        ? 'migrationNotApproved'
        : ''
}
